/* eslint-disable import/order */
import { LazyIssueApp } from '@jira/issue__lazy-app/src/LazyIssueApp.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { fieldsResource } from '@jira/router-resources__business-fields/src/fieldsResource.tsx';
// eslint-disable-next-line jira/import/no-restricted-import, camelcase
import { DEPRECATED_DO_NOT_USE_projectDetailsResource } from '@jira/router-resources__business-project-details/src/BusinessProjectDetailsUseProjectDEPRECATEDDONOTUSE.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { softwareListEmbedClassicRoute } from '@jira/router-routes__classic-projects-routes/src/softwareListEmbedClassicRoute.tsx';
import { ListEmbedSkeleton } from '@jira/platform__skeletons/src/ui/list/ListSkeleton.tsx';
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';

import { projectCreatePermissionsResource } from '@jira/router-resources__project-permissions/src/projectCreatePermissionsResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { getIssueViewResources } from '@jira/router-resources__issue-view/src/getIssueViewResources.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { NIN_NEW_ISSUE_NAVIGATOR } from '@jira/platform__observability-capabilities/src/constants.tsx';
import { getRouteReporting } from '@jira/router-routes__issue-navigator-entries/src/common/getRouteReporting.tsx';
import { getCommonProjectResources } from '@jira/router-routes__issue-navigator-entries/src/common/getCommonProjectResources.tsx';
import { issueNavigatorEmbedPageEntryPoint } from '@jira/router-routes__issue-navigator-entries/src/ui/index.tsx';
import { EmbedIssueNavigatorSkeleton } from '@jira/platform__skeletons/src/ui/issue-navigator/components/embed-app.tsx';
import { softwareListEmbedRouteEntry } from './ui/software/list/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const softwareListEmbedClassicRouteEntry: Route = createEntry(
	softwareListEmbedClassicRoute,
	() => ({
		group: 'classic-software',

		meta: fg('jira_list_nin_merge')
			? {
					capability: NIN_NEW_ISSUE_NAVIGATOR,
					reporting: getRouteReporting(),
				}
			: undefined,

		skeleton: fg('jira_list_nin_merge') ? EmbedIssueNavigatorSkeleton : ListEmbedSkeleton,

		entryPoint() {
			if (fg('jira_list_nin_merge')) {
				return issueNavigatorEmbedPageEntryPoint;
			}
			return softwareListEmbedRouteEntry;
		},

		layout: chromelessLayout,

		// TODO: This is a copy of getProjectViewResources, but it has been copied in order to expand getNavigationSidebarProjectResource
		resources: fg('jira_list_nin_merge')
			? [...getCommonProjectResources(), ...getIssueViewResources()]
			: [
					// the below 5 resources are copied from getBusinessProjectResources
					// they should be feature flagged and removed when it is safe to do so or
					// moved out of business packages
					// start getBusinessProjectResources
					projectCreatePermissionsResource,
					// eslint-disable-next-line camelcase
					DEPRECATED_DO_NOT_USE_projectDetailsResource,
					// end getBusinessProjectResources
					...getNavigationResources(),
					...getIssueViewResources(),
					// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
					// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
					incidentExperimentTraitResource,
					projectContextResource,
					forgeProjectModuleResource,
					staticProjectSidebarNavigationResource,
					staticProjectSidebarConnectAddonsNavigationResource,
					// end of resources expanded from getNavigationSidebarProjectResource
					fieldsResource,
				],

		isHydrateRootEnabled: fg('jira_list_nin_merge'),
		isStreamingEnabled: fg('jfp-magma-ssr-streaming-enable-nin'),

		afterPaint: fg('jira_list_nin_merge') ? undefined : [LazyIssueApp],
		ufoName: fg('jira_list_nin_merge') ? 'classic-list-nin-embed' : 'classic-list-embed',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
